export enum ProfileConstantsEnum {
  registrationAttributes = 'registrationAttributes',
  registrationAccountType = 'registrationAccountType',
  shareCodeAttributes = 'sharecodeAttributes',
  accountRenewalAttributes = 'accountRenewalAttributes',
  registrationInfoKey = 'registrationInfo',
}
export default ProfileConstantsEnum;
